import Api from 'utils/api'
import config from 'config'
import { trackDailyActiveAudience } from 'utils/metrika'
import {
  setNavMetricsUser,
  trackDirectEntry,
  getNavMetricsHomeVariant,
} from 'utils/navMetrics'
import * as actions from './actions'

export const checkAuth =
  (ignoreSessionStorage) => async (dispatch, getState) => {
    dispatch(actions.checkAuth())
    // if (getState().auth.isLoggedIn && !ignoreSessionStorage) return
    try {
      const user = await Api.request(
        `/users/me?app=${config.redirectUri}`,
        {},
        config.ssoUri
      )
      dispatch(actions.signIn(user))
      // У пользователя SSO нет uuid — только числовой id (MeSerializer).
      trackDailyActiveAudience({
        userId: user?.id,
        companyUuid: user?.company?.uuid,
        homeVariant: getNavMetricsHomeVariant(),
      })
      setNavMetricsUser({
        userId: user?.id,
        companyUuid: user?.company?.uuid,
      })
      // С какой страницы началась загрузка: прямая ссылка на подъезд /
      // устройство, перезагрузка или главная (business_apps#1465).
      trackDirectEntry()
    } catch (err) {
      // 401 уже уводит на SSO внутри utils/api (_handleError → redirectToSso)
      if (err && err.status !== 401) {
        try {
          const { redirect_to } = await err.json()
          if (redirect_to) {
            window.location = config.ssoUri + redirect_to
          }
        } catch (_) {
          // тело не-JSON (например, 502 от балансировщика) — просто ошибка входа
        }
      }
      dispatch(actions.signInError())
    }
  }

export const logOut = () => async (dispatch) => {
  dispatch(actions.logOutRequest())
  try {
    const response = await Api.request(
      '/logout',
      { method: 'DELETE' },
      config.redirectUri
    )
    sessionStorage.clear()
    window.location.reload()
    dispatch(actions.logOutSuccess(response))
    return Promise.resolve()
  } catch (err) {
    dispatch(actions.logOutError(err))
    return Promise.reject(err)
  }
}
